export default {
    // ----------Title----------
    parcels: 'พัสดุ',
    newParcel: 'พัสดุใหม่',
    ownership: 'ความเป็นเจ้าของ',
    provideDetailsOfTheProfile: 'ให้รายละเอียดของโปรไฟล์',
    parcelDetails: 'รายละเอียดพัสดุ',
    provideTheInfoOfTheParcel: 'ให้ข้อมูลของพัสดุ',
    measurement: 'การวัด',
    provideDetailItemMeasurement: 'ให้รายละเอียดการวัดของรายการ',
    theItemReceiveAndDeliveryOrderWillCreateAutomatically: 'การรับรายการและใบสั่งส่งสินค้าจะถูกสร้างโดยอัตโนมัติ',

    // -----------MUI----------
    productCode: 'รหัสสินค้า',
    quantity: 'จำนวน',
    uom: 'หน่วยนับ',
    pricePerUnit: 'ราคาต่อหน่วย',
    volumeWeight: 'น้ำหนักตามปริมาตร',
    grossWeight: 'น้ำหนักรวม',
    netWeight: 'น้ำหนักสุทธิ',
}